import { LegalRedirect } from "@/components/legal-redirect";

/** The privacy policy is published on the environment's site (nodus.se/integritet); no copy here. */
export default function PrivacyPage() {
  return <LegalRedirect doc="privacy" />;
}
